import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { Body1, Body2, Heading3 } from '@estee/elc-typography';

import { classes } from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';

const FieldLabel = styled.span`
    &::after {
        content: ': ';
    }
`;

interface IUserInformationProps {
    userName?: string;
    userMobile?: string;
    userEmail?: string;
    showSignUpTitle: boolean;
}

interface IUserInformationFragmentProps {
    bodyClassName?: string;
    fieldLabel?: string;
    fieldValue?: string;
}

const emailClassNames = classes('iam-email-text');
const mobileClassNames = classes('iam-mobile-number-text');
const userNameClassNames = classes('iam-user-name-text');
const fieldLabelClassNames = classes('iam-field-label');
const fieldValueClassNames = classes('iam-field-value');

const UserInformationFragment = observer((props: IUserInformationFragmentProps) => {
    const { bodyClassName, fieldLabel, fieldValue } = props;

    return (
        <Body1 className={bodyClassName}>
            <FieldLabel className={fieldLabelClassNames}>{fieldLabel}</FieldLabel>
            <span className={fieldValueClassNames}>{fieldValue}</span>
        </Body1>
    );
});

export const UserInformation = observer((props: IUserInformationProps) => {
    const { userName, userEmail, userMobile, showSignUpTitle } = props;
    const {
        signUpLabel,
        signUpText,
        fullNameLabel,
        mobileNumberLabel,
        emailLabel
    } = useTranslation();

    return (
        <>
            {showSignUpTitle && (
                <>
                    <Heading3>{signUpLabel}</Heading3>
                    <Body2 dangerouslySetInnerHTML={{ __html: signUpText }} />
                </>
            )}
            {userName && (
                <UserInformationFragment
                    bodyClassName={userNameClassNames}
                    fieldLabel={fullNameLabel}
                    fieldValue={userName}
                />
            )}
            {userEmail && (
                <UserInformationFragment
                    bodyClassName={emailClassNames}
                    fieldLabel={emailLabel}
                    fieldValue={userEmail}
                />
            )}

            {userMobile && (
                <UserInformationFragment
                    bodyClassName={mobileClassNames}
                    fieldLabel={mobileNumberLabel}
                    fieldValue={userMobile}
                />
            )}
        </>
    );
});
